import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cartSlice";
import storeReducer from "./storeSlice";
import authReducer from "./authSlice";
import orderOptionReducer from "./orderOptionSlice";

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    store: storeReducer,
    auth: authReducer,
    orderOption: orderOptionReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Persist cart-related things to localStorage
store.subscribe(() => {
  const state = store.getState();
  const { cart, store: storeState } = state;

  try {
    localStorage.setItem("cart_id", cart.cartId);
    localStorage.setItem("cart_menu_id", cart.menuId);
    localStorage.setItem("cart", JSON.stringify(cart.items));
    localStorage.setItem("cart_store_id", JSON.stringify(cart.cartStoreId));
    localStorage.setItem("uusid", JSON.stringify(cart.uusid));
    localStorage.setItem("olo_utm", storeState.utm);
  } catch {
    // ignore
  }
});
